<template>
    <div>
        <div class="tools-background-overlay" @click="toggleFacilitatorControls" v-if="showFacilitatorControls"></div>
        <div class="toolsbar-control-wrapper">
            <div class="facilitator-controls"
                ref="facilitatorControls"
                :class="{ 'hide': !showFacilitatorControls, 
                        'facilitator-controls-has-only-control' : controlsLength === 3,
                        'facilitator-controls-has-two-controls': controlsLength === 4,
                        'facilitator-controls-has-three-controls': controlsLength === 5,
                        'facilitator-controls-has-more-controls': controlsLength === 6}"
                v-show="controls['facilitationControls']">
                <div class="close-icon" v-if="showFacilitatorControls" @click="toggleFacilitatorControls">
                    <IconBase :width="24" :height="24" :fill="'#1C1C29'"
                        :view-box="`0 0 24 24`">
                        <IconCross />
                    </IconBase>
                </div>
                <div class="toolbar" @click="toggleFacilitatorControls">
                    <div class="arrow" :class="{ 'shift-right': !showFacilitatorControls }"
                        :title="showFacilitatorControls ? 'Hide controls' : 'Show Controls'">
                        <IconBase :class="[showFacilitatorControls ? 'arrow--right' : 'arrow--left']"
                            :width="24"
                            :height="24" :view-box="`0 0 24 24`" :fill="'#FFFFFF'">
                            <IconAngleDown />
                        </IconBase>
                    </div>
                    <div class="toolbar--title">Tools</div>
                </div>
                <div class="control" v-if="controls['WHITEBOARD']">
                    <WhiteBoard />
                </div>
                <div class="control" v-if="controls['CREATE_POLL']">
                    <ThumbsVote />
                </div>
                <div class="control" v-if="controls['BROADCAST_MESSAGE']">
                    <BroadCastMessage />
                </div>
                <div class="control" v-if="controls['TIMER']">
                    <timer />
                </div>
                <div class="control" v-if="controls['FORCE_TO_LOBBY']">
                    <door-open />
                </div>
                <div class="control" v-if="controls['NEED_HELP']">
                    <NeedHelp />
                </div>
                <!-- <div class="control">
                    <BreakOuts v-if="controls['CREATE_BREAKOUTS']"/>
                </div> -->
                <!-- <div class="control" v-if="controls['HANDS_LIST']">
                    <RaiseHand />
                </div> -->
                <!-- <div class="control"> -->
                <!-- <LastN v-if="controls['LAST_N']"/> -->
                <!-- </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import NeedHelp from "./room//NeedHelp";
import DoorOpen from "./room//DoorOpen";
import Timer from "./timer/Timer";
import WhiteBoard from "./room/WhiteBoard";
import BroadCastMessage from "./room/BroadCastMessage";
// import LastN from "./room/LastN";
import ThumbsVote from "./room/ThumbsVote";
// import RaiseHand from "./room/RaiseHand";
import IconBase from "./IconBase";
import IconAngleDown from "./icons/IconAngleDown";
import IconCross from "./icons/IconCross";

import { mapState } from "vuex";
export default {
    props: ["tileViewEnabled", "filmStripVisible"],
    name: "Controls",
    components: {
        NeedHelp,
        DoorOpen,
        Timer,
        WhiteBoard,
        BroadCastMessage,
        // LastN,
        // RaiseHand,
        ThumbsVote,
        IconBase,
        IconAngleDown,
        IconCross
    },
    data: function() {
        return {
            controlsLength: 0
        }
    },
    mounted() {
        this.positionControls();
        window.addEventListener('resize', this.handleResize);
    },
    methods: {
        toggleFacilitatorControls() {
            this.$store.commit("rooms/toggleFacilitatorControls");
            if(this.showFacilitatorControls) {
                this.handleResize();
            }
        },
        positionControls() {
            this.$nextTick(() => {
                // facilitator controls element
                const controlsElement = this.$refs.facilitatorControls;
                // check number of controls
                this.controlsLength = controlsElement.childNodes.length;
            });
        },
        handleResize() {
            // facilitator controls element
            var controlsParentElement = this.$refs.facilitatorControls;
            if(controlsParentElement.clientHeight) {
                // check number of controls
                var controlsLength = controlsParentElement.childNodes.length;
                // 20 is the padding applied to the element, 72 is each control height. 
                let controlsPerColumn = Math.floor((controlsParentElement.clientHeight - 20) / 72);
                // -2 is subtracting the count of toolbar and close elements, 72 is each control width.
                let elemWidth = Math.ceil((controlsLength - 2) / controlsPerColumn) * 72;
                // set width to controls element
                controlsParentElement.style.setProperty("width", `${elemWidth}px`);
            }
        }
    },
    watch: {
        controls() {
            this.positionControls();
        },
    },
    computed: {
        ...mapState({
            controls: (state) => state.user.controls,
            room: (state) => state.rooms.currentRoom,
            showFacilitatorControls: (state) => state.rooms.showFacilitatorControls,
        }),
    },
};
</script>

<style scoped>
>>> button.ctrl-btn.el-button:hover,
>>> button.ctrl-btn.el-button.active {
    background-color: #aeaafa;
    color: #1c1c29;
    text-decoration: none;
}

>>> button.el-button.ctrl-btn {
    width: 100%;
    border-radius: 0;
}

/* Had to do some tweaks to make svg change color on hover*/
>>> button.el-button:hover span svg g,
>>> button.el-button:hover div svg g,
>>> button.el-button:hover div svg g g path,
>>> button.el-button:hover span svg g g path,
>>> button.el-button:hover span svg g g rect,
>>> button.el-button.active span svg g,
>>> button.el-button.active div svg g,
>>> button.el-button.active div svg g g path,
>>> button.el-button.active span svg g g path,
>>> button.el-button.active span svg g g rect {
    fill: #1c1c29;
}

/* Prevent changing fill color for + icon on add link button */
>>> button.add-button.el-button:hover span svg g,
>>> button.add-button.el-button:hover div svg g,
>>> button.add-button.el-button:hover div svg g g path,
>>> button.add-button.el-button:hover span svg g g path,
>>> button.add-button.el-button.active span svg g,
>>> button.add-button.el-button.active div svg g,
>>> button.add-button.el-button.active div svg g g path,
>>> button.add-button.el-button.active span svg g g path {
    fill: #e7e6fa;
}

>>> button.el-button--text {
    color: #e7e6fa;
    font-size: 12px;
    line-height: 15px;
}

>>> .ctrl-icon {
    margin: 0 auto 10px auto;
}

>>> .ctrl-100 {
    width: 100%;
}

>>> .el-textarea__inner,
>>> .el-input__inner {
    background-color: #393752;
    border-radius: 3px;
    border: none;
    resize: none;
    color: #e7e6fa;
}

>>> .ctrl {
    position: relative;
}

>>> .ctrl-window__overlay {
    position: fixed;
    top: 56px;
    left: 0;
    height: 100vh;
    width: 100vmax;
    background: #000;
    opacity: 0.5;
    z-index: 1;
    background: rgba(174, 170, 250, 0.5);
}

>>> .ctrl-window {
    position: absolute;
    width: 360px;
    height: 224px;
    top: 0;
    right: 72px;
    background: #2a2a3d;
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 3px 3px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    text-align: left;
    padding: 0 12px 12px 12px;
    z-index: 2;
    writing-mode: initial;
}

>>> .ctrl__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

>>> .ctrl__title {
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    color: #e7e6fa;
}

>>> .ctrl__footer {
    display: flex;
    justify-content: flex-end;
}

>>> .ctrl__form {
    margin-bottom: 24px;
}

>>> .fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

>>> .fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}

>>> .el-input .el-input__inner,
>>> .el-textarea .el-textarea__inner {
    color: #e7e6fa;
    font-weight: 400;
    font-family: Arial, Helvetica, sans-serif;
}

>>> .el-input .el-input__inner::-webkit-input-placeholder,
>>> .el-textarea .el-textarea__inner::-webkit-input-placeholder {
    /* Edge */
    color: rgba(231, 230, 250, 0.4);
    font-family: inherit;
}

>>> .el-input .el-input__inner:-ms-input-placeholder,
>>> .el-textarea .el-textarea__inner:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: rgba(231, 230, 250, 0.4);
    font-family: inherit;
}

>>> .el-input .el-input__inner::placeholder,
>>> .el-textarea .el-textarea__inner::placeholder {
    color: rgba(231, 230, 250, 0.4);
    font-family: inherit;
}

@media (max-width: 767px) {
    >>> .ctrl-window__overlay {
        display: none;
    }
    
    >>> .ctrl-window {
        position: fixed;
        top: 56px;
        bottom: 0;
        left: 0;
        right: 0;
        border-radius: 0;
        width: 100% !important;
        height: 100% !important;
        padding: 0px 12px;
        box-sizing: border-box;
    }

    >>> .dialog {
        inset: 56px 0px 0px;
        border-radius: 0px;
        min-width: unset;
        min-height: unset;
        max-width: none;
        max-height: none;
        width: auto;
        height: auto;
        cursor: auto;
        writing-mode: initial;
    }

    >>> .dialog-box {
        height: 100%;
    }

    >>> .dialog-body {
        max-height: calc(100% - 100px);
    }
}

@media (hover: none) {
    >>> .ctrl-window__overlay {
        display: none;
    }

    >>> .ctrl-window {
        position: fixed;
        top: 56px;
        bottom: 0;
        left: 0;
        right: 0;
        border-radius: 0;
        width: 100% !important;
        height: 100% !important;
        padding: 0px 12px;
        box-sizing: border-box;
    }

    >>> .dialog {
        inset: 56px 0px 0px;
        border-radius: 0px;
        min-width: unset;
        min-height: unset;
        max-width: none;
        max-height: none;
        width: auto;
        height: auto;
        cursor: auto;
        writing-mode: initial;
    }

    >>> .dialog-box {
        height: 100%;
    }

    >>> .dialog-body {
        max-height: calc(100% - 100px);
    }
}
</style>

<style scoped>

.tools-background-overlay {
    position: absolute;
    top: 56px;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(174, 170, 250, 0.5);
    display: none;
    z-index: 11;
}

.close-icon {
    margin: 6px;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    display: none;
    cursor: pointer;
    position: absolute;
    left: -52px;
}

.close-icon span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.toolsbar-control-wrapper {
    position: fixed;
    right: 0;
    height: 100%;
    display: flex;
    align-items: center;
    top: 56px;
    height: calc(100% - 56px);
}

.toolbar {
    position: absolute;
    left: -40px;
    width: 40px;
    height: 84px;
    padding: 18px 0px;
    background: #1C1C28;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 8px 0px 0px 8px;
    color: #E7E6FA;
    cursor: pointer;
    top: calc(50% - 186px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    visibility: visible;
}

.toolbar .toolbar--title {
    writing-mode: vertical-lr;
    text-orientation: mixed;
    padding-bottom: 10px;
    transform: rotate(180deg);
}

.facilitator-controls {
    display: flex;
    flex-direction: column;
    z-index: 12;
    transition: all 0.5s ease-in-out;
    border-radius: 9px 0 0 9px;
    background: #1c1c29;
    padding: 10px 0px;
    width: 72px;
    visibility: visible;
}

.facilitator-controls.hide {
    width: 0 !important;
    visibility: hidden;
    transition: all 0.5s ease-in-out;
}

.facilitator-controls.hide .control {
    width: 0;
    visibility: hidden;
    transition: all 0.5s ease-in-out;
}

.facilitator-controls-has-only-control.facilitator-controls {
    height: 120px;
    justify-content: center;
    border-radius: 0px;
    box-sizing: border-box;
    top: calc(38% - 5px);
}

.facilitator-controls-has-only-control .toolbar {
    top: calc(50% - 60px);
}

.facilitator-controls-has-two-controls .toolbar {
    top: 16%;
}

.facilitator-controls-has-two-controls.facilitator-controls {
    top: calc(38% - 3px);
}

.facilitator-controls-has-three-controls .toolbar {
    top: 26%;
}

.facilitator-controls-has-three-controls.facilitator-controls {
    top: calc(38% - 2px);
}

.facilitator-controls-has-more-controls.facilitator-controls {
    top: calc(41% - 4px);
}

.facilitator-controls-has-more-controls .toolbar {
    top: 26%;
}

.toolbar .arrow {
    font-weight: 600;
    transition: right ease-in 0.3s;
}

.arrow .arrow--right {
    transform: rotate(-90deg);
}

.arrow .arrow--left {
    transform: rotate(90deg);
}

.el-footer {
    padding-bottom: 13px;
    position: relative;
    height: fit-content !important;
    vertical-align: center;
}

.el-footer .el-button--default {
    padding: 6px;
}

.facilitation-control-not-visible {
    padding-right: 35px;
    padding-top: 0px;
    padding-bottom: 0px;
}

.facilitation-control-visible {
    padding-top: 0px;
    padding-bottom: 0px;
}

.visibility-set-icon {
    fill: #f7f7f7;
}

.visibility-set-icon:hover,
.visibility-set-icon-active {
    fill: #409eff;
}

.control {
    font-size: 12px;
    line-height: 15px;
    color: #e7e6fa;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 72px;
    background: #1c1c29;
    visibility: visible;
    transition: all 0.5s ease-in-out;
}

@media (max-width: 767px) {
    .tools-background-overlay {
        display: block;
    }

    .close-icon {
        display: flex;
    }

    .toolbar {
        top: 72px !important;
    }

    .toolsbar-control-wrapper {
        align-items: start;
        top: 56px;
        z-index: 11;
    }

    .facilitator-controls {
        top: 56px !important;
        border-radius: 0px 0 0 9px;
        flex-wrap: wrap-reverse;
        max-height: 60%;
    }

    .facilitator-controls-has-only-control .close-icon {
        left: 20px;
    }

    .arrow {
        position: relative;
    }

    .arrow[title]:hover:after{
        content: attr(title);
        display: none;
    }
}
@media (hover: none) {
    .tools-background-overlay {
        display: block;
    }

    .close-icon {
        display: flex;
    }

    .toolbar {
        top: 72px !important;
    }

    .toolsbar-control-wrapper {
        align-items: start;
        top: 56px;
        z-index: 11;
    }

    .facilitator-controls {
        top: 56px !important;
        border-radius: 0px 0 0 9px;
        flex-wrap: wrap-reverse;
        max-height: 60%;
    }

    .facilitator-controls-has-only-control .close-icon {
        left: 20px;
    }

    .arrow {
        position: relative;
    }

    .arrow[title]:hover:after{
        content: attr(title);
        display: none;
    }   
}
</style>
